/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OrderRefundReason = {
    AUTO_REFUND: 'AUTO_REFUND',
    WRONG_ORDER_RECEIVED: 'WRONG_ORDER_RECEIVED',
    ORDER_NEVER_ARRIVED: 'ORDER_NEVER_ARRIVED',
    ITEM_QUALITY_ISSUES: 'ITEM_QUALITY_ISSUES',
    MISSING_OR_INCORRECT_ITEMS: 'MISSING_OR_INCORRECT_ITEMS',
    ORDER_ARRIVED_LATE: 'ORDER_ARRIVED_LATE',
    THIRD_PARTY_ISSUED: 'THIRD_PARTY_ISSUED',
    OTHER: 'OTHER'
} as const;
export type OrderRefundReason = typeof OrderRefundReason[keyof typeof OrderRefundReason];


export function instanceOfOrderRefundReason(value: any): boolean {
    for (const key in OrderRefundReason) {
        if (Object.prototype.hasOwnProperty.call(OrderRefundReason, key)) {
            if (OrderRefundReason[key as keyof typeof OrderRefundReason] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OrderRefundReasonFromJSON(json: any): OrderRefundReason {
    return OrderRefundReasonFromJSONTyped(json, false);
}

export function OrderRefundReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderRefundReason {
    return json as OrderRefundReason;
}

export function OrderRefundReasonToJSON(value?: OrderRefundReason | null): any {
    return value as any;
}

export function OrderRefundReasonToJSONTyped(value: any, ignoreDiscriminator: boolean): OrderRefundReason {
    return value as OrderRefundReason;
}

